import { render, staticRenderFns } from "./OmnichatFooter.vue?vue&type=template&id=3144bc92&"
import script from "./OmnichatFooter.vue?vue&type=script&lang=js&"
export * from "./OmnichatFooter.vue?vue&type=script&lang=js&"
import style0 from "./OmnichatFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports